module.exports = __webpack_public_path__ + "static/img/cont50 (2).0d8c21a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont50 (2).jpg
// module id = oH4m
// module chunks = 0